import { formatNumber } from '@/utils/NumberHelper';

export const MetersToMiles = (metters, decimals = 2) => {
  const kilometers = metters / 1000;
  const miles = kilometers * 0.621371;
  return formatNumber(miles, { decimals });
};
